import * as React from 'react'

import { cn } from '../utils'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string
  iconLeft?: React.ReactNode
  iconRight?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, iconLeft, iconRight, ...props }, ref) => {
    return (
      <div className="relative w-full">
        {iconLeft && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">
            {iconLeft}
          </div>
        )}
        <input
          type={type}
          className={cn(
            'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
            error && 'border-destructive focus-visible:ring-destructive',
            className,
            {
              'pl-10': iconLeft,
              'pr-10': iconRight,
            },
          )}
          aria-invalid={error ? 'true' : undefined}
          aria-errormessage={error}
          ref={ref}
          {...props}
        />
        {iconRight && <div className="absolute right-3 top-3">{iconRight}</div>}
      </div>
    )
  },
)
Input.displayName = 'Input'

export { Input }
